import React from "react";
import idHelper from "@irati/utils/id";
import ChangeView from "./ChangeView";
import HomePageGreeting from "./Greeting";
import { Wrapper } from "./styled";
var HomePageHeader = function (props) {
    var onChangePreview = props.onChangePreview, showPreview = props.showPreview;
    var id = idHelper("header", props);
    return (React.createElement(Wrapper, { id: id, justifyContent: "space-between" },
        React.createElement(HomePageGreeting, null),
        showPreview && React.createElement(ChangeView, { id: id, onChangePreview: onChangePreview })));
};
export default HomePageHeader;
